export default __webpack_public_path__ + "static/media/linkedin.a724aae3.svg";